(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[217],{

/***/ 85794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[office]/[game]",
      function () {
        return __webpack_require__(20034);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FloatingActionButton_FloatingActionButton; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./src/components/Navbar/Navbar.tsx + 21 modules
var Navbar = __webpack_require__(61197);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/portal/portal.mjs
var portal = __webpack_require__(796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/v-stack.mjs
var v_stack = __webpack_require__(10461);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tooltip/tooltip.mjs + 4 modules
var tooltip = __webpack_require__(48353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/button/icon-button.mjs
var icon_button = __webpack_require__(56943);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(55521);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/shared/FloatingActionButton/FloatingActionButton.tsx




const FloatingActionButton = (param)=>{
    let { buttons  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal/* Portal */.h, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v_stack/* VStack */.g, {
            position: "fixed",
            top: "calc(env(safe-area-inset-top) + 8px + ".concat(Navbar/* NAVBAR_HEIGHT */.i, ")"),
            right: 4,
            zIndex: "docked",
            children: buttons.filter((button)=>button.isHidden !== true).map((button)=>{
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tooltip/* Tooltip */.u, {
                    label: button.label,
                    placement: "left",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                        children: button.onClick ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_button/* IconButton */.h, {
                            onClick: button.onClick,
                            colorScheme: button.colorScheme,
                            "aria-label": button.label,
                            icon: button.icon,
                            css: {
                                aspectRatio: "1"
                            },
                            isLoading: button.isLoading
                        }) : button.href ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: button.href,
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_button/* IconButton */.h, {
                                colorScheme: button.colorScheme,
                                as: "a",
                                "aria-label": button.label,
                                icon: button.icon,
                                css: {
                                    aspectRatio: "1"
                                },
                                isLoading: button.isLoading
                            })
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_button/* IconButton */.h, {
                            isDisabled: true,
                            colorScheme: button.colorScheme,
                            "aria-label": button.label,
                            icon: button.icon,
                            css: {
                                aspectRatio: "1"
                            },
                            isLoading: button.isLoading
                        })
                    })
                }, button.label + button.href + button.colorScheme);
            })
        })
    });
};
/* harmony default export */ var FloatingActionButton_FloatingActionButton = (FloatingActionButton);

;// CONCATENATED MODULE: ./src/components/shared/FloatingActionButton/index.ts



/***/ }),

/***/ 31447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LoadingIcon_LoadingIcon; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(3276);
;// CONCATENATED MODULE: ./src/components/shared/LoadingIcon/LoadingIcon.tsx



const Wrapper = (0,motion/* motion */.E)(box/* Box */.x);
const LoadingIcon = (param)=>{
    let { color , size =8  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        animate: {
            rotate: 360
        },
        transition: {
            repeat: Infinity,
            duration: 2
        },
        color: color,
        h: size,
        w: size,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
            viewBox: "0 0 100 100",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.rect */.E.rect, {
                    y: "50",
                    width: "50",
                    height: "50",
                    rx: "8",
                    fill: "currentColor",
                    animate: {
                        y: -25,
                        x: 25
                    },
                    transition: {
                        repeat: Infinity,
                        repeatType: "reverse",
                        duration: 2
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.rect */.E.rect, {
                    x: "50",
                    width: "50",
                    height: "50",
                    rx: "8",
                    fill: "currentColor",
                    animate: {
                        y: 25,
                        x: -25
                    },
                    transition: {
                        repeat: Infinity,
                        repeatType: "reverse",
                        duration: 2
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.path */.E.path, {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M50 25C50 38.8071 38.8071 50 25 50L25 75L50 75C50 61.1929 61.1929 50 75 50L75 25L50 25Z",
                    fill: "currentColor",
                    animate: {
                        scale: 0.5
                    },
                    transition: {
                        repeat: Infinity,
                        repeatType: "reverse",
                        duration: 2
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var LoadingIcon_LoadingIcon = (LoadingIcon);

;// CONCATENATED MODULE: ./src/components/shared/LoadingIcon/index.ts



/***/ }),

/***/ 21118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Settings_Settings; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/form-control/form-control.mjs
var form_control = __webpack_require__(58921);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/color-mode/color-mode-context.mjs
var color_mode_context = __webpack_require__(18850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(542);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs
var heading = __webpack_require__(26801);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs + 2 modules
var stack = __webpack_require__(80883);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(55521);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.3.1/node_modules/react-icons/vsc/index.esm.js
var index_esm = __webpack_require__(43288);
;// CONCATENATED MODULE: ./src/components/shared/Settings/Settings.tsx







const Item = (param)=>{
    let { children , label , htmlFor  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(form_control/* FormControl */.NI, {
        fontSize: "sm",
        as: "li",
        display: "flex",
        py: 2,
        px: 4,
        alignItems: "center",
        minH: "4rem",
        justifyContent: "space-between",
        bg: "grey.3",
        children: [
            label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                as: "label",
                color: "grey.12",
                htmlFor: htmlFor,
                pr: 4,
                flex: 1,
                noOfLines: 1,
                children: label
            }),
            children
        ]
    });
};
const Action = (_param)=>{
    var { children , href , icon , helper , showChevron =true , highlight  } = _param, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href",
        "icon",
        "helper",
        "showChevron",
        "highlight"
    ]);
    const mode = (0,color_mode_context/* useColorModeValue */.ff)("", "Dark");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
        as: "li",
        bg: "grey.3",
        color: highlight ? "primary.10" : undefined,
        _hover: {
            bg: highlight ? "primary".concat(mode, ".4") : "grey.4"
        },
        _active: {
            bg: highlight ? "primary".concat(mode, ".5") : "grey.5"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                fontSize: "md",
                as: "a",
                display: "flex",
                py: 2,
                px: 4,
                minH: "4rem",
                justifyContent: "space-between",
                spacing: 4
            }, props), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                        w: "1.5em",
                        h: "1.5em",
                        bg: icon ? "grey.1" : undefined,
                        borderRadius: "lg",
                        lineHeight: "1.5em",
                        textAlign: "center",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                        flexGrow: 1,
                        children: [
                            children,
                            !!helper && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                                fontSize: "sm",
                                color: "grey.10",
                                children: helper
                            })
                        ]
                    }),
                    showChevron && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                        px: 2,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* VscChevronRight */.UKx, {})
                    })
                ]
            }))
        })
    });
};
const List = (_param)=>{
    var { children , label  } = _param, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "label"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(heading/* Heading */.X, {
                size: "sm",
                mb: 4,
                pl: 4,
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(stack/* Stack */.K, {
                as: "ul",
                listStyleType: "none",
                spacing: 0.5,
                sx: {
                    "&>*:first-of-type": {
                        borderTopRadius: "xl"
                    },
                    "&>*:last-child": {
                        borderBottomRadius: "xl"
                    }
                },
                children: children
            })
        ]
    }));
};
const Settings = {
    List,
    Item,
    Link: Action
};
/* harmony default export */ var Settings_Settings = (Settings);

;// CONCATENATED MODULE: ./src/components/shared/Settings/index.ts



/***/ }),

/***/ 88795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m2": function() { return /* binding */ hasProp; },
/* harmony export */   "wH": function() { return /* binding */ hasKey; }
/* harmony export */ });
/* unused harmony export getExactTypeFor */
function hasProp(data, prop) {
    return prop in data;
}
function hasKey(obj, key) {
    return key in obj;
}
const getExactTypeFor = ()=>(inputOutput)=>inputOutput;


/***/ }),

/***/ 20034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _game_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
;// CONCATENATED MODULE: ./src/components/shared/IconBlur/IconBlur.tsx






const drawBlur = (canvas, icon)=>{
    const context = canvas.getContext("2d");
    if (!context || !icon) return;
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = "".concat(Math.min(canvas.width, canvas.height) / 2, "px serif");
    context.textBaseline = "middle";
    const { width  } = context.measureText(icon);
    context.fillText(icon, (canvas.width - width) / 2, canvas.height / 2);
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    for(let i = 0, n = imageData.data.length; i < n; i += 4){
        imageData.data[i + 3] = 255;
    }
    context.putImageData(imageData, 0, 0);
};
const IconBlur = (_param)=>{
    var { icon  } = _param, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "icon"
    ]);
    const canvasRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        canvasRef.current && drawBlur(canvasRef.current, icon || "");
    }, [
        icon
    ]);
    if (!icon) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        overflow: "hidden",
        sx: {
            maskImage: "radial-gradient(closest-side, rgba(0,0,0,1), rgba(0,0,0,0))"
        },
        left: "0",
        top: "0",
        position: "absolute",
        w: "100%",
        h: "100%",
        filter: "saturate(200%)"
    }, boxProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("canvas", {
            ref: canvasRef,
            style: {
                height: "100%",
                top: 0,
                left: 0,
                width: "100%"
            },
            height: "1",
            width: "1"
        })
    }));
};
/* harmony default export */ var IconBlur_IconBlur = (IconBlur);

;// CONCATENATED MODULE: ./src/components/shared/IconBlur/index.ts


// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(542);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs
var heading = __webpack_require__(26801);
;// CONCATENATED MODULE: ./src/components/GamePage/PageHeader/PageHeader.tsx




const PageHeader = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { title , subtitle , icon  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
        py: 8,
        position: "relative",
        zIndex: 0,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconBlur_IconBlur, {
                pointerEvents: "none",
                icon: icon,
                height: "400%",
                opacity: 0.2,
                transform: {
                    base: "translate(-50%, -50%)",
                    md: "translate(-50%, -66%)"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                spacing: 4,
                align: "baseline",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                        fontSize: "3xl",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(heading/* Heading */.X, {
                                position: "relative",
                                as: "h1",
                                size: "xl",
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(heading/* Heading */.X, {
                                position: "relative",
                                fontWeight: "normal",
                                size: "md",
                                color: "grey.9",
                                children: subtitle
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
PageHeader.displayName = "PageHeader";
/* harmony default export */ var PageHeader_PageHeader = (PageHeader);

;// CONCATENATED MODULE: ./src/components/GamePage/PageHeader/index.ts


// EXTERNAL MODULE: ./src/components/Navbar/Navbar.tsx + 21 modules
var Navbar = __webpack_require__(61197);
// EXTERNAL MODULE: ./src/components/shared/FloatingActionButton/index.ts + 1 modules
var FloatingActionButton = __webpack_require__(32863);
// EXTERNAL MODULE: ./src/components/shared/LatestMatches/index.ts + 7 modules
var LatestMatches = __webpack_require__(83910);
// EXTERNAL MODULE: ./src/components/shared/Leaderboard/index.ts + 4 modules
var Leaderboard = __webpack_require__(95484);
// EXTERNAL MODULE: ./src/components/shared/LoadingIcon/index.ts + 1 modules
var LoadingIcon = __webpack_require__(31447);
// EXTERNAL MODULE: ./src/components/shared/Toast/index.ts + 1 modules
var Toast = __webpack_require__(73706);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./src/lib/types/utils.ts
var utils = __webpack_require__(88795);
;// CONCATENATED MODULE: ./src/lib/api/getErrorMessage.ts


const errorSchema = (0,es/* object */.Ry)({
    data: (0,es/* object */.Ry)({
        message: (0,es/* string */.Z_)()
    })
});
const getErrorMessage = async (error)=>{
    if (error && typeof error === "object" && (0,utils/* hasProp */.m2)(error, "response")) {
        return await errorSchema.validate(error.response, {
            abortEarly: false,
            stripUnknown: true
        }).then((error)=>error.data.message || null).catch((e)=>{
            console.log(e);
            return null;
        });
    }
    return null;
};
/* harmony default export */ var api_getErrorMessage = (getErrorMessage);

// EXTERNAL MODULE: ./src/lib/mixpanel.ts + 1 modules
var mixpanel = __webpack_require__(50164);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-disclosure.mjs
var use_disclosure = __webpack_require__(46175);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/toast/use-toast.mjs + 2 modules
var use_toast = __webpack_require__(52889);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/button/button.mjs + 4 modules
var button_button = __webpack_require__(96756);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs + 2 modules
var stack = __webpack_require__(80883);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/modal/modal.mjs + 2 modules
var modal = __webpack_require__(28985);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/modal/modal-overlay.mjs + 1 modules
var modal_overlay = __webpack_require__(751);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/modal/modal-content.mjs + 22 modules
var modal_content = __webpack_require__(87732);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/modal/modal-close-button.mjs
var modal_close_button = __webpack_require__(58039);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/modal/modal-body.mjs
var modal_body = __webpack_require__(25229);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/center/center.mjs
var center = __webpack_require__(11321);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/modal/modal-footer.mjs
var modal_footer = __webpack_require__(87338);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(75616);
// EXTERNAL MODULE: ./node_modules/.pnpm/axios@0.25.0/node_modules/axios/index.js
var axios = __webpack_require__(72698);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-auth@4.24.11_next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@1_acaee22c3ffd625475c47b7b2c959a5f/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(25096);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dynamic.js
var dynamic = __webpack_require__(71905);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.56.4_react@18.3.1/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(35134);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.3.1/node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(49812);
;// CONCATENATED MODULE: ./src/components/shared/NewMatchButton/NewMatchButton.tsx
















const Teams = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(539), __webpack_require__.e(792)]).then(__webpack_require__.bind(__webpack_require__, 92792)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(92792)
            ]
    },
    ssr: false,
    loading: ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingIcon/* default */.Z, {
            color: "grey.4",
            size: 4
        })
});
const Scores = dynamic_default()(()=>__webpack_require__.e(/* import() */ 558).then(__webpack_require__.bind(__webpack_require__, 26558)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(26558)
            ]
    },
    ssr: false
});
const NewMatchButton = (_param)=>{
    var { gameId , season , maxPlayersPerTeam  } = _param, chakraProps = (0,_object_without_properties/* default */.Z)(_param, [
        "gameId",
        "season",
        "maxPlayersPerTeam"
    ]);
    const { status  } = (0,next_auth_react.useSession)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const isLoggedIn = status === "authenticated";
    const { 0: isLoading , 1: setIsLoading  } = (0,react.useState)(false);
    const { isOpen , onOpen , onClose  } = (0,use_disclosure/* useDisclosure */.q)();
    const form = (0,index_esm/* useForm */.cI)();
    const toast = (0,use_toast/* useToast */.p)();
    if (!isLoggedIn) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        w: "100%",
        bg: "grey.4",
        size: "lg",
        isDisabled: true
    }, chakraProps), {
        children: "Sign in to submit a match!"
    }));
    const onSubmit = async (data)=>{
        setIsLoading(true);
        const req = {
            left: {
                players: data.left.map((param)=>{
                    let { id , source  } = param;
                    return {
                        id,
                        source: source || "user"
                    };
                }),
                score: data.leftscore
            },
            right: {
                players: data.right.map((param)=>{
                    let { id , source  } = param;
                    return {
                        id,
                        source: source || "user"
                    };
                }),
                score: data.rightscore
            },
            seasonId: season.id
        };
        try {
            const res = await axios_default().post("/api/matches", req).then((res)=>res.data);
            if (res.status !== "ok") throw new Error("Error creating match");
            toast({
                render: ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* default */.Z, {
                        status: "success",
                        heading: "Well done",
                        content: "Your match has been added."
                    }),
                position: "bottom"
            });
            (0,mixpanel/* trackEvent */.L9)("Match created", {
                gameId,
                left: data.left.map((param)=>{
                    let { id  } = param;
                    return id;
                }),
                right: data.right.map((param)=>{
                    let { id  } = param;
                    return id;
                }),
                leftscore: data.leftscore,
                rightscore: data.rightscore
            });
            form.resetField("leftscore");
            form.resetField("rightscore");
            queryClient.invalidateQueries([
                "matches",
                {
                    gameId
                }
            ]);
            queryClient.invalidateQueries([
                "leaderboard",
                {
                    gameId,
                    seasonId: season.id
                }
            ]);
            queryClient.invalidateQueries([
                "opponents",
                {
                    gameId
                }
            ]);
        } catch (error) {
            const errorMessage = await api_getErrorMessage(error) || "An error occurred when adding your match.";
            (0,mixpanel/* trackEvent */.L9)("Error creating match");
            toast({
                render: ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* default */.Z, {
                        status: "error",
                        heading: "Let’s try that again",
                        content: errorMessage
                    }),
                position: "bottom"
            });
            return;
        } finally{
            setIsLoading(false);
            onClose();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                w: "100%",
                variant: "primary",
                size: "lg",
                onClick: onOpen,
                leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoAddCircleOutline */.RWZ, {
                    size: 24
                })
            }, chakraProps), {
                children: season.name ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(stack/* Stack */.K, {
                    align: "flex-start",
                    spacing: 0,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                            as: "span",
                            fontSize: "xs",
                            display: "block",
                            textTransform: "uppercase",
                            letterSpacing: "widest",
                            fontWeight: "medium",
                            children: season.name
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                            as: "span",
                            children: "Submit new match"
                        })
                    ]
                }) : "Submit new match"
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(modal/* Modal */.u_, {
                isOpen: isOpen,
                onClose: onClose,
                size: "xl",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(modal_overlay/* ModalOverlay */.Z, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(modal_content/* ModalContent */.h, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(modal_close_button/* ModalCloseButton */.o, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(modal_body/* ModalBody */.f, {
                                pt: 6,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
                                        id: "new-match",
                                        onSubmit: form.handleSubmit(onSubmit),
                                        children: isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(center/* Center */.M, {
                                            py: 16,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingIcon/* default */.Z, {
                                                color: "grey.6",
                                                size: 16
                                            })
                                        }) : isOpen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(stack/* Stack */.K, {
                                            spacing: 8,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Teams, {
                                                    gameId: gameId,
                                                    seasonId: season.id,
                                                    maxPlayersPerTeam: maxPlayersPerTeam || 1
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Scores, {})
                                            ]
                                        }) : null
                                    })
                                }))
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(modal_footer/* ModalFooter */.m, {
                                pb: 6,
                                flexDir: "column",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, {
                                    variant: "primary",
                                    flexGrow: "1",
                                    type: "submit",
                                    form: "new-match",
                                    w: "100%",
                                    size: "lg",
                                    children: "Submit"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NewMatchButton_NewMatchButton = (NewMatchButton);

;// CONCATENATED MODULE: ./src/components/shared/NewMatchButton/index.ts


// EXTERNAL MODULE: ./src/components/shared/SEO/index.ts + 1 modules
var SEO = __webpack_require__(10923);
// EXTERNAL MODULE: ./src/components/shared/Settings/index.ts + 1 modules
var Settings = __webpack_require__(21118);
// EXTERNAL MODULE: ./src/lib/navigationHistory/useNavigationState.ts
var useNavigationState = __webpack_require__(25094);
// EXTERNAL MODULE: ./src/lib/roles.ts
var roles = __webpack_require__(42780);
// EXTERNAL MODULE: ./src/lib/styleUtils.ts
var styleUtils = __webpack_require__(25198);
// EXTERNAL MODULE: ./src/lib/useMediaQuery.ts
var useMediaQuery = __webpack_require__(66339);
// EXTERNAL MODULE: ./src/lib/utils/formatDateTime.ts
var formatDateTime = __webpack_require__(3277);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/container/container.mjs
var container = __webpack_require__(83658);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/grid/grid.mjs
var grid = __webpack_require__(89479);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tabs/tabs.mjs
var tabs = __webpack_require__(60841);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tabs/tab-list.mjs
var tab_list = __webpack_require__(47034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tabs/tab.mjs
var tab = __webpack_require__(31546);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tabs/tab-panels.mjs
var tab_panels = __webpack_require__(76035);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tabs/tab-panel.mjs
var tab_panel = __webpack_require__(72270);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.3.1/node_modules/react-icons/vsc/index.esm.js
var vsc_index_esm = __webpack_require__(43288);
;// CONCATENATED MODULE: ./src/components/GamePage/GamePage.tsx




















const GamePage = (param)=>{
    let { game  } = param;
    var ref, ref1;
    (0,useNavigationState/* default */.Z)(game === null || game === void 0 ? void 0 : game.name);
    const isDesktop = (0,useMediaQuery/* default */.Z)("xl");
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const headerRef = (0,react.useRef)(null);
    const { data: session  } = (0,next_auth_react.useSession)();
    const activeSeasons = (ref = game.seasons) === null || ref === void 0 ? void 0 : ref.filter((season)=>!season.endDate).sort((a, b)=>a.startDate < b.startDate ? -1 : a.startDate > b.startDate ? 1 : 0);
    const inactiveSeasons = (ref1 = game.seasons) === null || ref1 === void 0 ? void 0 : ref1.filter((season)=>!!season.endDate).sort((a, b)=>a.startDate < b.startDate ? -1 : a.startDate > b.startDate ? 1 : 0);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(container/* Container */.W, {
        maxW: "container.lg",
        pt: Navbar/* NAVBAR_HEIGHT */.i,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageHeader_PageHeader, {
                title: game.name,
                subtitle: "at the ".concat(game.office.name, " office"),
                icon: game === null || game === void 0 ? void 0 : game.icon,
                ref: headerRef
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SEO/* default */.Z, {
                title: game === null || game === void 0 ? void 0 : game.name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingActionButton/* default */.Z, {
                buttons: [
                    {
                        label: "edit",
                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(vsc_index_esm/* VscEdit */.$jT, {}),
                        colorScheme: "success",
                        href: "/admin/games/".concat(game.id),
                        isHidden: !(0,roles/* canViewDashboard */.bL)(session === null || session === void 0 ? void 0 : session.user.roleId)
                    },
                    {
                        label: "refresh",
                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoRefreshSharp */.I0U, {}),
                        colorScheme: "grey",
                        onClick: ()=>{
                            queryClient.invalidateQueries([
                                "matches",
                                {
                                    gameId: game.id
                                }
                            ]);
                            queryClient.invalidateQueries([
                                "leaderboard",
                                {
                                    gameId: game.id
                                }
                            ]);
                        },
                        isLoading: false
                    }, 
                ]
            }),
            isDesktop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(grid/* Grid */.r, {
                position: "relative",
                w: "100%",
                gap: 8,
                templateColumns: {
                    base: "1fr",
                    xl: "2fr 1fr"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                        as: "section",
                        bg: "grey.4",
                        borderRadius: "xl",
                        alignSelf: "start",
                        minH: "100vh",
                        overflow: "hidden",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tabs/* Tabs */.m, {
                            isLazy: true,
                            variant: "typographic",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tab_list/* TabList */.t, {
                                    children: [
                                        game.seasons.length > 1 ? activeSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                                children: season.name
                                            }, season.id)) : activeSeasons.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                            children: "Leaderboard"
                                        }) : null,
                                        inactiveSeasons.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                            children: "Past seasons"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tab_panels/* TabPanels */.n, {
                                    children: [
                                        activeSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab_panel/* TabPanel */.x, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard/* default */.Z, {
                                                    bg: "grey.4",
                                                    seasonId: season.id,
                                                    gameId: game.id,
                                                    stickyMe: true,
                                                    offsetPlayerBottom: ".5rem"
                                                })
                                            }, season.id)),
                                        inactiveSeasons.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab_panel/* TabPanel */.x, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Settings/* default.List */.Z.List, {
                                                children: inactiveSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Settings/* default.Link */.Z.Link, {
                                                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                                                            w: "1.5rem",
                                                            h: "1.5rem",
                                                            borderRadius: "lg",
                                                            bgColor: "#".concat(season.colour)
                                                        }),
                                                        href: "/".concat(game.office.slug, "/").concat(game.slug, "/").concat(season.slug),
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                                                children: season.name
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                                                                fontSize: "xs",
                                                                textTransform: "uppercase",
                                                                letterSpacing: "widest",
                                                                color: "grey.11",
                                                                children: [
                                                                    (0,formatDateTime/* formatDateTime */.o)(new Date(season.startDate), {
                                                                        dateStyle: "short"
                                                                    }),
                                                                    season.endDate && (0,formatDateTime/* formatDateTime */.o)(new Date(season.endDate), {
                                                                        dateStyle: "short"
                                                                    }), 
                                                                ].join("—")
                                                            })
                                                        ]
                                                    }, season.id))
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                        as: "section",
                        position: "sticky",
                        top: "calc(".concat(Navbar/* NAVBAR_HEIGHT */.i, " + .5rem)"),
                        h: "calc(100vh - ".concat(Navbar/* NAVBAR_HEIGHT */.i, " - 1rem)"),
                        overflow: "auto",
                        px: 4,
                        mx: -4,
                        css: styleUtils/* default */.ZP,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                                as: "header",
                                position: "sticky",
                                top: "0",
                                zIndex: "docked",
                                _before: {
                                    zIndex: "-1",
                                    content: "''",
                                    position: "absolute",
                                    inset: "0 calc(var(--wrkplay-space-4) * -1)",
                                    bg: "var(--wrkplay-colors-grey-2)",
                                    maskImage: "linear-gradient(to top, rgba(0,0,0,0) , rgba(0,0,0,1) 33%) ",
                                    pointerEvents: "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(heading/* Heading */.X, {
                                        as: "h2",
                                        size: "md",
                                        pb: 4,
                                        color: "grey.10",
                                        children: "Latest matches"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(stack/* Stack */.K, {
                                        mb: 8,
                                        children: activeSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewMatchButton_NewMatchButton, {
                                                season: season,
                                                gameId: game.id,
                                                maxPlayersPerTeam: game.maxPlayersPerTeam || 1
                                            }, season.id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LatestMatches/* default */.Z, {
                                gameId: game.id
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                                "aria-hidden": true,
                                zIndex: "2",
                                position: "sticky",
                                height: "4rem",
                                width: "100%",
                                bottom: "0",
                                left: "0",
                                _before: {
                                    zIndex: "-1",
                                    content: "''",
                                    position: "absolute",
                                    inset: "0",
                                    bg: "var(--wrkplay-colors-grey-2)",
                                    maskImage: "linear-gradient(to bottom, rgba(0,0,0,0) , rgba(0,0,0,1) 75%) "
                                }
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(stack/* Stack */.K, {
                        children: activeSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewMatchButton_NewMatchButton, {
                                season: season,
                                gameId: game.id,
                                maxPlayersPerTeam: game.maxPlayersPerTeam || 1
                            }, season.id))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tabs/* Tabs */.m, {
                        variant: "bottom",
                        onChange: ()=>{
                            window.scrollTo(0, 0);
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SEO/* default */.Z, {
                                title: game.name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tab_list/* TabList */.t, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                        children: "Leaderboard"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                        children: "Latest Matches"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tab_panels/* TabPanels */.n, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab_panel/* TabPanel */.x, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tabs/* Tabs */.m, {
                                            isLazy: true,
                                            variant: "typographic",
                                            mx: -4,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tab_list/* TabList */.t, {
                                                    children: [
                                                        game.seasons.length > 1 ? activeSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                                                children: season.name
                                                            }, season.id)) : activeSeasons.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                                            pointerEvents: "none",
                                                            children: "Leaderboard"
                                                        }) : null,
                                                        inactiveSeasons.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab/* Tab */.O, {
                                                            children: "Past seasons"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(tab_panels/* TabPanels */.n, {
                                                    children: [
                                                        activeSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab_panel/* TabPanel */.x, {
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard/* default */.Z, {
                                                                    bg: "grey.2",
                                                                    seasonId: season.id,
                                                                    gameId: game.id,
                                                                    stickyMe: true,
                                                                    offsetPlayerBottom: "calc(env(safe-area-inset-bottom) + 48px - .5rem)"
                                                                })
                                                            }, season.id)),
                                                        inactiveSeasons.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab_panel/* TabPanel */.x, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Settings/* default.List */.Z.List, {
                                                                children: inactiveSeasons.map((season)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Settings/* default.Link */.Z.Link, {
                                                                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                                                                            w: "1.5rem",
                                                                            h: "1.5rem",
                                                                            borderRadius: "lg",
                                                                            bgColor: "#".concat(season.colour)
                                                                        }),
                                                                        href: "/".concat(game.office.slug, "/").concat(game.slug, "/").concat(season.slug),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                                                                fontWeight: "bold",
                                                                                children: season.name
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                                                                                fontSize: "xs",
                                                                                textTransform: "uppercase",
                                                                                letterSpacing: "widest",
                                                                                color: "grey.11",
                                                                                children: [
                                                                                    (0,formatDateTime/* formatDateTime */.o)(new Date(season.startDate), {
                                                                                        dateStyle: "short"
                                                                                    }),
                                                                                    season.endDate && (0,formatDateTime/* formatDateTime */.o)(new Date(season.endDate), {
                                                                                        dateStyle: "short"
                                                                                    }), 
                                                                                ].join("—")
                                                                            })
                                                                        ]
                                                                    }, season.id))
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tab_panel/* TabPanel */.x, {
                                        pt: {
                                            base: 8,
                                            md: 4
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LatestMatches/* default */.Z, {
                                            gameId: game.id
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GamePage_GamePage = (GamePage);

;// CONCATENATED MODULE: ./src/components/GamePage/index.ts


;// CONCATENATED MODULE: ./src/pages/[office]/[game]/index.tsx

var __N_SSG = true;
/* harmony default export */ var _game_ = (GamePage_GamePage);


/***/ }),

/***/ 74352:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41902);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95558);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54678);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6793);
'use client';







const Badge = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Badge2(props, ref) {
  const styles = (0,_system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .m)("Badge", props);
  const { className, ...rest } = (0,_chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .L)(props);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__/* .chakra.span */ .m.span,
    {
      ref,
      className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-badge", props.className),
      ...rest,
      __css: {
        display: "inline-block",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        ...styles
      }
    }
  );
});
Badge.displayName = "Badge";




/***/ }),

/***/ 61521:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ PopoverArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95558);
/* harmony import */ var _popover_context_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36740);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6793);
'use client';





const resolveVar = (scale, value) => value ? `${scale}.${value}, ${value}` : void 0;
function PopoverArrow(props) {
  const {
    bg,
    bgColor,
    backgroundColor,
    shadow,
    boxShadow,
    shadowColor,
    ...rest
  } = props;
  const { getArrowProps, getArrowInnerProps } = (0,_popover_context_mjs__WEBPACK_IMPORTED_MODULE_1__/* .usePopoverContext */ .lp)();
  const styles = (0,_popover_context_mjs__WEBPACK_IMPORTED_MODULE_1__/* .usePopoverStyles */ .SV)();
  const arrowBg = bg ?? bgColor ?? backgroundColor;
  const arrowShadow = shadow ?? boxShadow;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _system_factory_mjs__WEBPACK_IMPORTED_MODULE_2__/* .chakra.div */ .m.div,
    {
      ...getArrowProps(),
      className: "chakra-popover__arrow-positioner",
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        _system_factory_mjs__WEBPACK_IMPORTED_MODULE_2__/* .chakra.div */ .m.div,
        {
          className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_3__.cx)("chakra-popover__arrow", props.className),
          ...getArrowInnerProps(rest),
          __css: {
            "--popper-arrow-shadow-color": resolveVar("colors", shadowColor),
            "--popper-arrow-bg": resolveVar("colors", arrowBg),
            "--popper-arrow-shadow": resolveVar("shadows", arrowShadow),
            ...styles.arrow
          }
        }
      )
    }
  );
}
PopoverArrow.displayName = "PopoverArrow";




/***/ }),

/***/ 35401:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PopoverBody; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95558);
/* harmony import */ var _popover_context_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36740);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6793);
'use client';






const PopoverBody = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function PopoverBody2(props, ref) {
    const { getBodyProps } = (0,_popover_context_mjs__WEBPACK_IMPORTED_MODULE_2__/* .usePopoverContext */ .lp)();
    const styles = (0,_popover_context_mjs__WEBPACK_IMPORTED_MODULE_2__/* .usePopoverStyles */ .SV)();
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _system_factory_mjs__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m.div,
      {
        ...getBodyProps(props, ref),
        className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-popover__body", props.className),
        __css: styles.body
      }
    );
  }
);
PopoverBody.displayName = "PopoverBody";




/***/ }),

/***/ 92142:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ PopoverFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95558);
/* harmony import */ var _popover_context_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36740);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6793);
'use client';





function PopoverFooter(props) {
  const styles = (0,_popover_context_mjs__WEBPACK_IMPORTED_MODULE_1__/* .usePopoverStyles */ .SV)();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _system_factory_mjs__WEBPACK_IMPORTED_MODULE_2__/* .chakra.footer */ .m.footer,
    {
      ...props,
      className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_3__.cx)("chakra-popover__footer", props.className),
      __css: styles.footer
    }
  );
}
PopoverFooter.displayName = "PopoverFooter";




/***/ }),

/***/ 47034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ TabList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44719);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95558);
/* harmony import */ var _tabs_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60841);
/* harmony import */ var _use_tabs_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45623);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6793);
'use client';








const TabList = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function TabList2(props, ref) {
    const tablistProps = (0,_use_tabs_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useTabList */ .hp)({ ...props, ref });
    const styles = (0,_tabs_mjs__WEBPACK_IMPORTED_MODULE_3__/* .useTabsStyles */ .s)();
    const tablistStyles = (0,_chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_4__/* .defineStyle */ .k0)({
      display: "flex",
      ...styles.tablist
    });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _system_factory_mjs__WEBPACK_IMPORTED_MODULE_5__/* .chakra.div */ .m.div,
      {
        ...tablistProps,
        className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_6__.cx)("chakra-tabs__tablist", props.className),
        __css: tablistStyles
      }
    );
  }
);
TabList.displayName = "TabList";




/***/ }),

/***/ 72270:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ TabPanel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95558);
/* harmony import */ var _tabs_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60841);
/* harmony import */ var _use_tabs_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45623);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6793);
'use client';







const TabPanel = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function TabPanel2(props, ref) {
    const panelProps = (0,_use_tabs_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useTabPanel */ .WE)({ ...props, ref });
    const styles = (0,_tabs_mjs__WEBPACK_IMPORTED_MODULE_3__/* .useTabsStyles */ .s)();
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m.div,
      {
        outline: "0",
        ...panelProps,
        className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-tabs__tab-panel", props.className),
        __css: styles.tabpanel
      }
    );
  }
);
TabPanel.displayName = "TabPanel";




/***/ }),

/***/ 76035:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ TabPanels; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95558);
/* harmony import */ var _tabs_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60841);
/* harmony import */ var _use_tabs_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45623);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6793);
'use client';







const TabPanels = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function TabPanels2(props, ref) {
    const panelsProps = (0,_use_tabs_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useTabPanels */ .bt)(props);
    const styles = (0,_tabs_mjs__WEBPACK_IMPORTED_MODULE_3__/* .useTabsStyles */ .s)();
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m.div,
      {
        ...panelsProps,
        width: "100%",
        ref,
        className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-tabs__tab-panels", props.className),
        __css: styles.tabpanels
      }
    );
  }
);
TabPanels.displayName = "TabPanels";




/***/ }),

/***/ 31546:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44719);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95558);
/* harmony import */ var _tabs_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60841);
/* harmony import */ var _use_tabs_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45623);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6793);
'use client';








const Tab = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Tab2(props, ref) {
  const styles = (0,_tabs_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useTabsStyles */ .s)();
  const tabProps = (0,_use_tabs_mjs__WEBPACK_IMPORTED_MODULE_3__/* .useTab */ .xD)({ ...props, ref });
  const tabStyles = (0,_chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_4__/* .defineStyle */ .k0)({
    outline: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...styles.tab
  });
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _system_factory_mjs__WEBPACK_IMPORTED_MODULE_5__/* .chakra.button */ .m.button,
    {
      ...tabProps,
      className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_6__.cx)("chakra-tabs__tab", props.className),
      __css: tabStyles
    }
  );
});
Tab.displayName = "Tab";




/***/ }),

/***/ 60841:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Tabs; },
/* harmony export */   "s": function() { return /* binding */ useTabsStyles; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41902);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54242);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95558);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75271);
/* harmony import */ var _use_tabs_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45623);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6579);
/* harmony import */ var _system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54678);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6793);
'use client';









const [TabsStylesProvider, useTabsStyles] = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .createContext */ .k)({
  name: `TabsStylesContext`,
  errorMessage: `useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tabs />" `
});
const Tabs = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .G)(function Tabs2(props, ref) {
  const styles = (0,_system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useMultiStyleConfig */ .j)("Tabs", props);
  const { children, className, ...rest } = (0,_chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_5__/* .omitThemingProps */ .L)(props);
  const { htmlProps, descendants, ...ctx } = (0,_use_tabs_mjs__WEBPACK_IMPORTED_MODULE_6__/* .useTabs */ .YE)(rest);
  const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => ctx, [ctx]);
  const { isFitted: _, ...rootProps } = htmlProps;
  const tabsStyles = {
    position: "relative",
    ...styles.root
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_use_tabs_mjs__WEBPACK_IMPORTED_MODULE_6__/* .TabsDescendantsProvider */ .mE, { value: descendants, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_use_tabs_mjs__WEBPACK_IMPORTED_MODULE_6__/* .TabsProvider */ .X, { value: context, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabsStylesProvider, { value: styles, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _system_factory_mjs__WEBPACK_IMPORTED_MODULE_7__/* .chakra.div */ .m.div,
    {
      className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_8__.cx)("chakra-tabs", className),
      ref,
      ...rootProps,
      __css: tabsStyles,
      children
    }
  ) }) }) });
});
Tabs.displayName = "Tabs";




/***/ }),

/***/ 45623:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mE": function() { return /* binding */ TabsDescendantsProvider; },
  "X": function() { return /* binding */ TabsProvider; },
  "xD": function() { return /* binding */ useTab; },
  "hp": function() { return /* binding */ useTabList; },
  "WE": function() { return /* binding */ useTabPanel; },
  "bt": function() { return /* binding */ useTabPanels; },
  "YE": function() { return /* binding */ useTabs; }
});

// UNUSED EXPORTS: useTabIndicator, useTabsContext, useTabsDescendant, useTabsDescendants, useTabsDescendantsContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-callback-ref.mjs
var use_callback_ref = __webpack_require__(71136);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-controllable-state.mjs
'use client';



function useControllableProp(prop, state) {
  const controlled = typeof prop !== "undefined";
  const value = controlled ? prop : state;
  return useMemo(() => [controlled, value], [controlled, value]);
}
function useControllableState(props) {
  const {
    value: valueProp,
    defaultValue,
    onChange,
    shouldUpdate = (prev, next) => prev !== next
  } = props;
  const onChangeProp = (0,use_callback_ref/* useCallbackRef */.W)(onChange);
  const shouldUpdateProp = (0,use_callback_ref/* useCallbackRef */.W)(shouldUpdate);
  const [uncontrolledState, setUncontrolledState] = (0,react.useState)(defaultValue);
  const controlled = valueProp !== void 0;
  const value = controlled ? valueProp : uncontrolledState;
  const setValue = (0,use_callback_ref/* useCallbackRef */.W)(
    (next) => {
      const setter = next;
      const nextValue = typeof next === "function" ? setter(value) : next;
      if (!shouldUpdateProp(value, nextValue)) {
        return;
      }
      if (!controlled) {
        setUncontrolledState(nextValue);
      }
      onChangeProp(nextValue);
    },
    [controlled, onChangeProp, value, shouldUpdateProp]
  );
  return [value, setValue];
}



// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-merge-refs.mjs
var use_merge_refs = __webpack_require__(88483);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/context.mjs
var context = __webpack_require__(54242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/call-all.mjs
var call_all = __webpack_require__(25631);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/children.mjs
var esm_children = __webpack_require__(31562);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/lazy.mjs
var lazy = __webpack_require__(96364);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/descendant/use-descendant.mjs + 2 modules
var use_descendant = __webpack_require__(21153);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/clickable/use-clickable.mjs + 1 modules
var use_clickable = __webpack_require__(1308);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tabs/use-tabs.mjs
'use client';






const [
  TabsDescendantsProvider,
  useTabsDescendantsContext,
  useTabsDescendants,
  useTabsDescendant
] = (0,use_descendant/* createDescendantContext */.n)();
function useTabs(props) {
  const {
    defaultIndex,
    onChange,
    index,
    isManual,
    isLazy,
    lazyBehavior = "unmount",
    orientation = "horizontal",
    direction = "ltr",
    ...htmlProps
  } = props;
  const [focusedIndex, setFocusedIndex] = (0,react.useState)(defaultIndex ?? 0);
  const [selectedIndex, setSelectedIndex] = useControllableState({
    defaultValue: defaultIndex ?? 0,
    value: index,
    onChange
  });
  (0,react.useEffect)(() => {
    if (index != null) {
      setFocusedIndex(index);
    }
  }, [index]);
  const descendants = useTabsDescendants();
  const uuid = (0,react.useId)();
  const uid = props.id ?? uuid;
  const id = `tabs-${uid}`;
  return {
    id,
    selectedIndex,
    focusedIndex,
    setSelectedIndex,
    setFocusedIndex,
    isManual,
    isLazy,
    lazyBehavior,
    orientation,
    descendants,
    direction,
    htmlProps
  };
}
const [TabsProvider, useTabsContext] = (0,context/* createContext */.k)({
  name: "TabsContext",
  errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
function useTabList(props) {
  const { focusedIndex, orientation, direction } = useTabsContext();
  const descendants = useTabsDescendantsContext();
  const onKeyDown = (0,react.useCallback)(
    (event) => {
      const nextTab = () => {
        const next = descendants.nextEnabled(focusedIndex);
        if (next)
          next.node?.focus();
      };
      const prevTab = () => {
        const prev = descendants.prevEnabled(focusedIndex);
        if (prev)
          prev.node?.focus();
      };
      const firstTab = () => {
        const first = descendants.firstEnabled();
        if (first)
          first.node?.focus();
      };
      const lastTab = () => {
        const last = descendants.lastEnabled();
        if (last)
          last.node?.focus();
      };
      const isHorizontal = orientation === "horizontal";
      const isVertical = orientation === "vertical";
      const eventKey = event.key;
      const ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
      const ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
      const keyMap = {
        [ArrowStart]: () => isHorizontal && prevTab(),
        [ArrowEnd]: () => isHorizontal && nextTab(),
        ArrowDown: () => isVertical && nextTab(),
        ArrowUp: () => isVertical && prevTab(),
        Home: firstTab,
        End: lastTab
      };
      const action = keyMap[eventKey];
      if (action) {
        event.preventDefault();
        action(event);
      }
    },
    [descendants, focusedIndex, orientation, direction]
  );
  return {
    ...props,
    role: "tablist",
    "aria-orientation": orientation,
    onKeyDown: (0,call_all/* callAllHandlers */.v)(props.onKeyDown, onKeyDown)
  };
}
function useTab(props) {
  const { isDisabled = false, isFocusable = false, ...htmlProps } = props;
  const { setSelectedIndex, isManual, id, setFocusedIndex, selectedIndex } = useTabsContext();
  const { index, register } = useTabsDescendant({
    disabled: isDisabled && !isFocusable
  });
  const isSelected = index === selectedIndex;
  const onClick = () => {
    setSelectedIndex(index);
  };
  const onFocus = () => {
    setFocusedIndex(index);
    const isDisabledButFocusable = isDisabled && isFocusable;
    const shouldSelect = !isManual && !isDisabledButFocusable;
    if (shouldSelect) {
      setSelectedIndex(index);
    }
  };
  const clickableProps = (0,use_clickable/* useClickable */.h)({
    ...htmlProps,
    ref: (0,use_merge_refs/* mergeRefs */.lq)(register, props.ref),
    isDisabled,
    isFocusable,
    onClick: (0,call_all/* callAllHandlers */.v)(props.onClick, onClick)
  });
  const type = "button";
  return {
    ...clickableProps,
    id: makeTabId(id, index),
    role: "tab",
    tabIndex: isSelected ? 0 : -1,
    type,
    "aria-selected": isSelected,
    "aria-controls": makeTabPanelId(id, index),
    onFocus: isDisabled ? void 0 : (0,call_all/* callAllHandlers */.v)(props.onFocus, onFocus)
  };
}
const [TabPanelProvider, useTabPanelContext] = (0,context/* createContext */.k)({});
function useTabPanels(props) {
  const context = useTabsContext();
  const { id, selectedIndex } = context;
  const validChildren = (0,esm_children/* getValidChildren */.W)(props.children);
  const children = validChildren.map(
    (child, index) => (0,react.createElement)(
      TabPanelProvider,
      {
        key: child.key ?? index,
        value: {
          isSelected: index === selectedIndex,
          id: makeTabPanelId(id, index),
          tabId: makeTabId(id, index),
          selectedIndex
        }
      },
      child
    )
  );
  return { ...props, children };
}
function useTabPanel(props) {
  const { children, ...htmlProps } = props;
  const { isLazy, lazyBehavior } = useTabsContext();
  const { isSelected, id, tabId } = useTabPanelContext();
  const hasBeenSelected = (0,react.useRef)(false);
  if (isSelected) {
    hasBeenSelected.current = true;
  }
  const shouldRenderChildren = (0,lazy/* lazyDisclosure */.k)({
    wasSelected: hasBeenSelected.current,
    isSelected,
    enabled: isLazy,
    mode: lazyBehavior
  });
  return {
    // Puts the tabpanel in the page `Tab` sequence.
    tabIndex: 0,
    ...htmlProps,
    children: shouldRenderChildren ? children : null,
    role: "tabpanel",
    "aria-labelledby": tabId,
    hidden: !isSelected,
    id
  };
}
function useTabIndicator() {
  const context = useTabsContext();
  const descendants = useTabsDescendantsContext();
  const { selectedIndex, orientation } = context;
  const isHorizontal = orientation === "horizontal";
  const isVertical = orientation === "vertical";
  const [rect, setRect] = useState(() => {
    if (isHorizontal)
      return { left: 0, width: 0 };
    if (isVertical)
      return { top: 0, height: 0 };
    return void 0;
  });
  const [hasMeasured, setHasMeasured] = useState(false);
  useSafeLayoutEffect(() => {
    if (selectedIndex == null)
      return;
    const tab = descendants.item(selectedIndex);
    if (tab == null)
      return;
    if (isHorizontal) {
      setRect({ left: tab.node.offsetLeft, width: tab.node.offsetWidth });
    }
    if (isVertical) {
      setRect({ top: tab.node.offsetTop, height: tab.node.offsetHeight });
    }
    const id = requestAnimationFrame(() => {
      setHasMeasured(true);
    });
    return () => {
      if (id) {
        cancelAnimationFrame(id);
      }
    };
  }, [selectedIndex, isHorizontal, isVertical, descendants]);
  return {
    position: "absolute",
    transitionProperty: "left, right, top, bottom, height, width",
    transitionDuration: hasMeasured ? "200ms" : "0ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    ...rect
  };
}
function makeTabId(id, index) {
  return `${id}--tab-${index}`;
}
function makeTabPanelId(id, index) {
  return `${id}--tabpanel-${index}`;
}




/***/ }),

/***/ 21617:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.36.1/node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(20822);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.36.1/node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(11933);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.36.1/node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(29567);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.36.1/node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    const {
      isFetching,
      isRefetching
    } = result;
    const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
    const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage,
      isFetchingPreviousPage,
      isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 4 modules
var useBaseQuery = __webpack_require__(53386);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs
'use client';



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [341,600,828,69,273,393,484,774,888,179], function() { return __webpack_exec__(85794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);